import { render, staticRenderFns } from "./batchmodify.vue?vue&type=template&id=34d5b68c&scoped=true&"
import script from "./batchmodify.vue?vue&type=script&lang=js&"
export * from "./batchmodify.vue?vue&type=script&lang=js&"
import style0 from "./batchmodify.vue?vue&type=style&index=0&id=34d5b68c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d5b68c",
  null
  
)

export default component.exports